import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
// import { List, Typography, Space } from 'antd';

import getIndividualQuotation from 'Api/actions/quotation/getIndividualQuotation';

import useGlobalQuotationProccessHandler from 'Hooks/useGlobalQuotationProccessHandler';
import { useLoading } from '@shared/hooks/useLoading';

import { storePackage, storeCoverages, storeAssists, addInactivePackages } from 'Redux/actions/globalQuotation';
import { setSelectedPackages, addPackageResponseAction, initializeInsuranceCarriersResponsesAction } from 'Redux/actions/comparationQuotationActions';

import QuotationComparatorPageView from './QuotationComparatorPageView';
import { QuotationLoadingScreen } from 'Pages/QuotationPage/components/QuotationLoadingScreen';
import { QUOTATION_INSURANCE_CARRIER_STATE } from '@shared/constants/quotationInsuranceCarrierStates';

import './styles.css';

// const { Paragraph, Text } = Typography;

const QuotationsComparatorPage = (props) => {
  const {
    // Actions
    storePackageAction,
    storeCoveragesAction,
    storeAssistsAction,
    addInactivePackagesAction,
    setSelectedPackagesAction,
    // resetGlobalQuotationQuotationAction,
    addPackageResponseActionProps,
    initializeInsuranceCarriersResponsesActionProp,

    pusher,
    showProgressBarLoader,
    // insuranceCarriersErrors,
    // insuranceCarriersAlerts,
    // insuranceCarriersDataDifferences,
  } = props;
  const { id } = useParams();

  const [quotationState, setQuotationState] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const firstSuccessfulQuotationLoading = useLoading(showProgressBarLoader);

  // Resetea el estado global de la Quotation para que NO se dupliquen los packages y las coverages
  const globalQuotationProccessHandler = useGlobalQuotationProccessHandler({ resetReducersOnMounth: false });

  useEffect(() => {
    let timeoutId;

    if (showProgressBarLoader) {
      const TIMEOUT_MS = 5000;
      timeoutId = setTimeout(() => {
        firstSuccessfulQuotationLoading.stop();
      }, TIMEOUT_MS);
    }

    const quotationInsuranceCarrierUpdateEventName = `${id}-QUOTATION_INSURANCE_CARRIER_UPDATE`;
    const errorEventName = `${id}-QUOTATION_ERROR`;
    const alertEventName = `${id}-QUOTATION_ALERT`;

    // Se suscriben los eventos con PUSHER para la recepción de los paquetes: actualizaciones, errores y alertas
    [quotationInsuranceCarrierUpdateEventName, errorEventName, alertEventName].forEach((eventName) => {
      pusher.unbind(eventName); // Limpiar suscripciones previas
      pusher.bind(eventName, (data) => {
        storePackageAction(data.package);
        addPackageResponseActionProps(data);

        // Si llega una cotización por aseguradora exitosa y QuotationLoadingScreen sigue activo, se lo detiene
        const isQuotationInsuranceCarrierSucceeded = data.package?.state === QUOTATION_INSURANCE_CARRIER_STATE.SUCCEEDED;
        if (eventName === quotationInsuranceCarrierUpdateEventName && firstSuccessfulQuotationLoading.isLoading && isQuotationInsuranceCarrierSucceeded) {
          firstSuccessfulQuotationLoading.stop();
          clearTimeout(timeoutId);
        }
      });
    });

    // // Suscribir el evento con PUSHER para la recepción de los paquetes
    // pusher.unbind(successEventName); // SE eliminan por si se pasa varias veces por estas líneas :)
    // pusher.bind(successEventName, (packageData) => {
    //   // console.info('|| `${quotationId}-QUOTATION_INSURANCE_CARRIER_PACKAGE` -------> ', `${quotationId}-QUOTATION_INSURANCE_CARRIER_PACKAGE`, packageData);
    //   // setInsuranceCarriersPackagesProps(data);
    //   storePackageAction(packageData.package);

    //   addPackageResponseActionProps(packageData);
    // });

    // // Suscribir el evento con PUSHER para el manejo de errores :)
    // pusher.unbind(errorEventName); // SE eliminan por si se pasa varias veces por estas líneas :)
    // pusher.bind(errorEventName, (errorData) => {
    //   // console.info('|| `${quotationId}-QUOTATION_ERROR` -------> ', `${quotationId}-QUOTATION_ERROR`, errorData);
    //   addPackageResponseActionProps(errorData);
    // });

    // // Suscribir el evento con PUSHER para el manejo de alertas :)
    // pusher.unbind(alertEventName); // SE eliminan por si se pasa varias veces por estas líneas :)
    // pusher.bind(alertEventName, (alertData) => {
    //   console.info('|| `${quotationId}-QUOTATION_ALERT` -------> ', `${quotationId}-QUOTATION_ALERT`, alertData);
    //   addPackageResponseActionProps(alertData);
    // });

    // Consultar la información del package
    setLoading(true);
    getIndividualQuotation(id)
      .then((quotationData) => {
        // const consulting = localStorage.getItem('consulting');
        // if (consulting === 'false' && quotationData.insurance_carrier_quotations.length === 0) {
        //   props.history.push(`/edit/${quotationData.id}`);
        //   return;
        // }

        setLoading(false);

        setQuotationState(quotationData);

        storeCoveragesAction(quotationData.coverages);
        storeAssistsAction(quotationData.assists);

        const selectedPackages = [];

        // Se agregan las cotizaciones exitosas al store y se identifican las seleccionadas
        quotationData.insurance_carrier_quotations.forEach((insuranceQuotationData) => {
          storePackageAction(insuranceQuotationData)

          if (insuranceQuotationData.selected) selectedPackages.push(insuranceQuotationData);
        });

        // Se agregan las cotizaciones fallidas al store (errores o alertas) junto con las exitosas
        quotationData.failed_insurance_carrier_quotations.forEach((failedQuotationData) => {
          storePackageAction(failedQuotationData)
        });

        // Se agregan las cotizaciones inactivas al store
        addInactivePackagesAction(quotationData.inactive_insurance_carrier_quotations);

        if (selectedPackages.length) setSelectedPackagesAction(selectedPackages);

        // Si no se está generando una nueva cotización, se inicializan las respuestas de las aseguradoras con la información de quotationData
        if (!showProgressBarLoader) initializeInsuranceCarriersResponsesActionProp(quotationData)
      }).catch(() => {
        setLoading(false);
        setError('No pudimos consultar la información de la cotización :(');
      });

    return () => {
      // Reiniciar Todos los reducers necesarios para que el "Global quitation" quede límpio
      globalQuotationProccessHandler.resetReducers();

      // Se eliminan las suscripciones a los eventos de PUSHER al desmontar el componente
      pusher.unbind(quotationInsuranceCarrierUpdateEventName);
      pusher.unbind(errorEventName);
      pusher.unbind(alertEventName);
    };
  }, []);

  if (error) return <h1>{error}</h1>;
  return (<>
    <QuotationComparatorPageView
      loading={loading}
      quotationData={quotationState}
      // insuranceCarriersErrors={insuranceCarriersErrors}
      // insuranceCarriersAlerts={insuranceCarriersAlerts}
      // insuranceCarriersDataDifferences={insuranceCarriersDataDifferences}
      showProgressBarLoader={showProgressBarLoader}
    />
    <QuotationLoadingScreen loading={firstSuccessfulQuotationLoading.isLoading} />
  </>);
};


const actions = {
  storePackageAction: storePackage,
  storeCoveragesAction: storeCoverages,
  storeAssistsAction: storeAssists,
  addInactivePackagesAction: addInactivePackages,
  setSelectedPackagesAction: setSelectedPackages,
  // resetGlobalQuotationQuotationAction: resetGlobalQuotationQuotation,
  addPackageResponseActionProps: addPackageResponseAction,
  initializeInsuranceCarriersResponsesActionProp: initializeInsuranceCarriersResponsesAction,
};

QuotationsComparatorPage.propTypes = {
  pusher: PropTypes.any.isRequired,
};

const mapStateToProps = (state) => {
  /*
  // Serializer los errores desde las respuestas de las aseguradoras
  const insuranceCarriersErrors = []; // !insuranceCarriersResponses ? [] : insuranceCarriersResponses
  const insuranceCarriersAlerts = [];
  const insuranceCarriersDataDifferences = [];

  const insuranceCarriersResponses = state.comparationQuotation.insuranceCarriersResponses;
  if (insuranceCarriersResponses) {
    for (let insuranceCarrierId in insuranceCarriersResponses) {
      const insuranceCarrierName = insuranceCarriersResponses[insuranceCarrierId].insurance_carrier_name;

      const errors = insuranceCarriersResponses[insuranceCarrierId].errors;
      if (errors?.length > 0) {
        insuranceCarriersErrors.push({
          title: <Text strong>{insuranceCarrierName}</Text>,
          description: (
            <List
              dataSource={errors}
              renderItem={({ message, plan }, index) => (
                <List.Item
                  style={{
                    paddingTop: index === 0 ? 0 : undefined, // Evita el padding-top en el primer elemento
                    paddingBottom: index === errors.length - 1 ? 0 : undefined, // Evita el padding-bottom en el último elemento
                  }}
                >
                  <Space direction='vertical' size={4}>
                    {plan?.name && <Text style={{ fontFamily: 'inherit' }}>Plan: <Text italic>{plan.name}</Text></Text>}
                    <Text style={{ fontFamily: 'inherit' }}>{message}</Text>
                  </Space>
                </List.Item>
              )}
            />
          ),
        });
      }

      insuranceCarriersResponses[insuranceCarrierId].alerts
        .forEach((badResp) => {
          insuranceCarriersAlerts.push({
            title: <Text strong>{insuranceCarrierName}</Text>,
            description: badResp.message
          });
        });

      // TODO: Actualmente, se asume que las inconsistencias son las mismas en todos los planes de la aseguradora,
      // por lo que solo se muestran las inconsistencias del primer plan. Sin embargo, se debe agregar la lógica para agrupar
      // y mostrar un único encabezado con los nombres de los planes cuando compartan las mismas inconsistencias.
      const dataDifferences = insuranceCarriersResponses[insuranceCarrierId].responses_packages[0]?.package.data_differences;
      if (dataDifferences?.length > 0) {
        // Retorna el valor en formato JSON si es un objeto, o el valor original si no lo es
        const renderValue = (value) => (
          typeof value === 'object' && value !== null
            ? <pre style={{ margin: 0 }}>{JSON.stringify(value, null, 2)}</pre>
            : value
        );

        insuranceCarriersDataDifferences.push({
          title: <Text strong>{insuranceCarrierName}</Text>,
          description: (
            <List
              // header={<Text>Plan: {insuranceCarriersResponses[insuranceCarrierId].responses_packages[0].package.package_detail}</Text>}
              dataSource={dataDifferences}
              renderItem={({ field, sent_value: sentValue, received_value: receivedValue, info_message: infoMessage }) => (
                <List.Item>
                  <Space direction='vertical' size={4}>
                    <Text>Campo: {field}</Text>
                    <Text>Valor enviado: {renderValue(sentValue)}</Text>
                    <Text>Valor recibido: {renderValue(receivedValue)}</Text>
                    {infoMessage && (
                      <Paragraph
                        italic
                        ellipsis={{ rows: 2, tooltip: true }}
                        style={{
                          color: '#00000099',
                          margin: 0,
                        }}
                      >
                        <span style={{ fontSize: '0.9rem' }}>*{infoMessage}</span>
                      </Paragraph>
                    )}
                  </Space>
                </List.Item>
              )}
            />
          ),
        });
      }
    }
  }
  */

  // ----------------------- ----------------------- ----------------------- -----------------------
  return {
    pusher: state.utilities.pusher,
    showProgressBarLoader: state.comparationQuotation.quotationPetitionAlive,
    /*
     insuranceCarriersErrors,
     insuranceCarriersAlerts,
     insuranceCarriersDataDifferences,
     */
  };
};

export default connect(mapStateToProps, actions)(QuotationsComparatorPage);
